<template>
	<div>
    <div class="title-logo" style="color: black;font-size: 16px; font-weight: bold">
          YJR 云锦荣
          <img src="../../assets/icon/nav-list-black.png" alt="" class="nav-icon" @click="navShow=true">
    </div>
		<transition name="fade">
			<div class="nav" v-if="navShow" @click="navShow=false">
				<div class="nav-content">
					<div @click="routerChange(1)">首页</div>
					<div  @click="routerChange(2)">产品矩阵</div>
					<div @click="routerChange(3)">案例介绍</div>
					<div>关于我们</div>
				</div>
				<img src="../../assets/icon/nav-close.png" alt="" class="nav-close">
			</div>
		</transition>
		<div class="banner">
			<img src="../../assets/img/about-banner1.png" alt="" class="banner-bg">
		</div>
		<div class="overview-list">
			<div class="overview-li">
				<div :class="idx==1?'active':''" @click="change(1)">公司概况</div>
				<div :class="idx==2?'active':''" @click="change(2)">企业文化</div>
			</div>
			<router-view></router-view>
		</div>
		<!-- 回到顶部 -->
		<img src="../../assets/icon/return-top.png" alt="" class="scroll-top" @click="scrollTop" v-if="returnShow">
	</div>
</template>

<script>
	export default({
		data(){
			return{
				idx:1,
                height:'2.12rem',
                navShow:false,
				screenHeight:'', //屏幕高度
				returnShow:false,  //是否显示返回顶部按钮
			}
		},
		mounted(){
			this.$nextTick(function() {
				let _this = this;
				_this.screenHeight=window.screen.height
				window.addEventListener("scroll", this.onScroll);
			});
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.onScroll)
		},
		methods:{
			change(i){
				this.idx=i
				if(i==1){
					this.$router.push('/about/overview')
				}else{
					this.$router.push('/about/enterprise')
				}
			},
			routerChange(i){
				this.$router.push({
					path:'/home',
					query:{
						i
					}
				})
			},
			onScroll(e){
				this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
				if(this.scroll>this.screenHeight){
					this.returnShow=true
				}else{
					this.returnShow=false
				}
			},
			scrollTop(){
				window.scroll({
					top:0,
					behavior:'smooth'
				})
			},
		}
	})
</script>

<style lang="scss" scoped>
    .title-logo{
        height:.75rem;
        width:100%;
        position: fixed;
        left:0;
        top:0;
        box-sizing: border-box;
        z-index: 10;
        display:flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        .logo{
            width:1.36rem;
            height:.41rem;
        }
        .nav-icon{
            position: absolute;
            left:.27rem;
            top:50%;
            transform: translateY(-50%);
            width:.41rem;
            height:.41rem;
        }
    
    }
    .nav{
        position: fixed;
        left:0;
        top:0;
        z-index: 20;
        height:100%;
        width:100%;
        background:rgba(0,0,0,0.45);
        overflow: hidden;
        .nav-content{
            width:4.63rem;
            background:#fff;
            height:100%;
            overflow: hidden;
        padding-top:2.08rem;
        >div{
            display:inline-block;
            width:100%;
            box-sizing: border-box;
            padding:.17rem .82rem;
            margin-bottom:.2rem;
            font-size: 0.29rem;
            line-height: 0.34rem;
        }
        }
        .nav-close{
            position: absolute;
            left:.27rem;
            top:.41rem;
            z-index: 10;
            width:.41rem;
            height:.41rem;
        }
    }
	.banner{
		width:100%;
		height:6.66rem;
		position: relative;
		margin-top:.75rem;
		.banner-bg{
			position: absolute;
			left:0;
			top:0;
			width:100%;
			height:100%;
           // object-fit:cover;
		}
		.banner-text{
			position: relative;
			z-index: 5;
			color:#fff;
			height:100%;
			display:flex;
			flex-direction: column;
			justify-content: center;
			>div:nth-child(1){
				font-size: 2.4rem;
				line-height: 2.81rem;
				font-weight: 900;
			}
			>div:nth-child(2){
				font-size:.8rem;
				line-height: 1.2rem;
				margin-top:.6rem;
			}
		}
			
	}
	.overview-list{
		.overview-li{
			display:flex;
			justify-content: center;
			background:#fff;
			>div{
				padding:.2rem 0;
				font-size: 0.27rem;
				color: #000000;
				line-height: 0.32rem;
				&:nth-child(2){
					margin-left:.82rem;
				}
				&.active{
					border-bottom:0.02rem solid #1790FF;
				}
			}
		}
	}
	.scroll-top{
		position: fixed;
		z-index: 110;
		right:.27rem;
		bottom:.62rem;
		width:.82rem;
		height:.82rem;
		border-radius: 50%;
	}
	.fade-enter-active, .fade-leave-active{
		transition: all .2s ease   
	}
	.fade-enter, .fade-leave-active{
		width: 0 
	}
</style>
